export default __webpack_public_path__ + "static/media/34_photo.2fdaa57c.jpeg";